import api from ".";

export const getPendingSettlements = (params) => api.get("/settlements/pending-settlement", { params });

export const getCollectionSettlements = (params) => api.get("/settlements/collection-settlement", { params });

export const getOutstandingSettlements = (params) => api.get("/settlements/outstanding-balance", { params });

export const getSettlementData = (params) => api.get("/settlements", { params });
